import React from "react";
import { useNavigate } from "react-router-dom";
import { useConfiguracionInicial } from "../Hooks/useConfiguracionInicial";
import {
  CONFIGURACION_INICIAL_RUTA,
  esEstadoProcesoDisponible,
  obtenerPrimero,
} from "../Utils/configuracionInicial.constants";
import "../configuracionInicialRecordatorio.css";

export const ConfiguracionInicialRecordatorio = () => {
  const navigate = useNavigate();
  const {
    estadoAcceso,
    disponible,
    puedeAcceder,
    bienvenidaVisible,
    consultandoEstado,
    guardando,
    posponer,
  } = useConfiguracionInicial();
  const estado = obtenerPrimero(estadoAcceso, ["Estado", "estado"], null);
  const mostrarRecordatorio = obtenerPrimero(
    estadoAcceso,
    ["MostrarRecordatorio", "mostrarRecordatorio"],
    false
  ) === true;

  if (
    consultandoEstado ||
    bienvenidaVisible ||
    !mostrarRecordatorio ||
    !disponible ||
    !puedeAcceder ||
    !esEstadoProcesoDisponible(estado)
  ) {
    return null;
  }

  return (
    <section
      className="ci-reminder"
      aria-label="Recordatorio de configuración inicial"
    >
      <div className="ci-reminder__message">
        <span className="ci-reminder__checklist" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <path d="M9 5h6v2H9V5Zm-2 6 1.4 1.4L11 9.8l1.4 1.4-4 4L5.6 12.4 7 11Zm2 6h6v2H9v-2Zm7-6h3v2h-3v-2Zm0 6h3v2h-3v-2ZM7 2h10a2 2 0 0 1 2 2v3h-2V4H7v16h10v-3h2v3a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z" />
          </svg>
        </span>
        <span className="ci-reminder__copy">
          <strong>Tu configuración inicial está pendiente.</strong>
          <span>Continúa donde te quedaste.</span>
        </span>
      </div>
      <div className="ci-reminder__actions">
        <button
          type="button"
          className="ci-reminder__continue"
          disabled={guardando}
          onClick={() => navigate(CONFIGURACION_INICIAL_RUTA)}
        >
          Continuar configuración
        </button>
        <button
          type="button"
          className="ci-reminder__dismiss"
          aria-label="Ocultar recordatorio de configuración inicial durante esta sesión"
          disabled={guardando}
          onClick={() => posponer().catch(() => {})}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
    </section>
  );
};
